import { Box, Typography, styled } from '@mui/material';

export const Container = styled(Box)(() => ({
  display: 'grid',
  width: '242.25px',
  height: '28px',
  padding: '4px',
  rowGap: '8px',
  columnGap: '8px',
  gridTemplateRows: 'repeat(1, minmax(0, 1fr))',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  borderRadius: '10px',
  background: 'var(--Background-2, #F5F5F7)',
  boxShadow: '0 1px 1.9px 1px rgba(0, 0, 0, 0.05) inset',
  alignItems: 'center',
}));

export const TabItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ active }) => ({
  display: 'flex',
  padding: '0 10px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px',
  alignSelf: 'stretch',
  gridRow: '1 / span 1',
  justifySelf: 'stretch',
  cursor: 'pointer',
  borderRadius: '6px',
  background: active ? 'var(--Card_Header, rgba(255, 255, 255, 0.90))' : 'transparent',
  boxShadow: active ? '0 1px 2px 1px rgba(0, 0, 0, 0.10)' : 'none',
  transition: 'all 0.2s ease',
  '&:hover': {
    background: active ? 'var(--Card_Header, rgba(255, 255, 255, 0.90))' : 'rgba(0, 0, 0, 0.02)',
  },
}));

export const TabText = styled(Typography)(() => ({
  color: 'var(--Typography-p-tertiary, #807D93)',
  textAlign: 'center',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  textTransform: 'capitalize',
}));
